import React from "react";
import CountrySelector from "../components/countrySelector.comp";

/**
 * Phone Input Component with Country Code Selector
 *
 * @param {Object} props - Component props
 * @param {string} props.countryCodeValue - Currently selected country code
 * @param {Function} props.onCountryCodeChange - Function to call when country code changes
 * @param {string} props.phoneValue - Current phone number value
 * @param {Function} props.onPhoneChange - Function to call when phone number changes
 * @param {boolean} props.required - Whether the phone input is required
 * @param {string} props.phoneLabel - Label for the phone input
 * @param {boolean} props.isChineseLanguage - Whether to use Chinese locale for country names
 * @param {string} props.phoneClassName - Additional classes for the phone input
 * @param {string} props.countryClassName - Additional classes for the country selector
 * @param {string} props.errorMessage - Error message to display
 */
const PhoneInput = ({
  countryCodeValue = "+852",
  onCountryCodeChange,
  phoneValue = "",
  onPhoneChange,
  required = false,
  phoneLabel = "Phone Number",
  isChineseLanguage = false,
  phoneClassName = "flex-1 px-3 py-2 border border-gray-300 rounded-r-md",
  countryClassName = "w-24 px-2 py-2 border border-gray-300 rounded-l-md bg-gray-50",
  errorMessage = "",
}) => {
  // Handle country code change
  const handleCountryCodeChange = (e) => {
    if (onCountryCodeChange) {
      onCountryCodeChange(e);
    }
  };

  return (
    <div>
      {phoneLabel && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {phoneLabel} {required && "*"}
        </label>
      )}
      <div className="flex">
        <div className="flex-none">
          <CountrySelector
            value={countryCodeValue}
            onChange={handleCountryCodeChange}
            isChineseLanguage={isChineseLanguage}
            className={countryClassName}
            showCountryName={false}
          />
        </div>
        <div className="flex-1">
          <input
            type="tel"
            className={phoneClassName}
            value={phoneValue}
            onChange={onPhoneChange}
            required={required}
            pattern="[0-9]*"
            inputMode="numeric"
          />
        </div>
      </div>
      {errorMessage && <p className="text-red-500 text-xs mt-1">{errorMessage}</p>}
    </div>
  );
};

export default PhoneInput;
